module.exports = __webpack_public_path__ + "static/turquia-019-28d1d7abe0359496933533652644c69d.jpg";